import './styles.scss';
import React from "react";
import {NavigateFunction} from "react-router/dist/lib/hooks";
import {useNavigate} from "react-router-dom";

/* Types, Constants, Utils */
import * as Constants from "../../../../constants";

/* Bootstrap */
import {ISearchState} from "../../../../types/redux/search";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../redux";
import LinkButton from "../../../button-link";
import {searchReset} from "../../../../redux/slices/search-slice";
import {resetResults} from "../../../../redux/slices/result-slice";

const BackSearch = ():JSX.Element => {
  /* redux */
  const searchState: ISearchState = useSelector<RootState, ISearchState>((state: RootState):any => state.search);
  const dispatch = useDispatch();

  /* hooks */
  const navigate:NavigateFunction = useNavigate();

  /* const */
  const searchParams: URLSearchParams = new URLSearchParams(window.location.search);

  const handleClick = ()=> {
    searchParams.delete(Constants.RECORD_TOOL_PARAM);
    if (searchParams.get(Constants.INDUSTRY)) {
      dispatch(searchReset())
      dispatch(resetResults())
      navigate('/' + searchState.industry + '/documents/?' + searchParams.toString())
    } else {
      /* arrive on viewer via document or permalink */
      navigate('/' + Constants.HOME + '/')
    }
  }

  return(
    <div className={'back-search'}>
      <LinkButton
        label={'Back to search'}
        underline={false}
        linkArrowReverse={true}
        clickFunc={handleClick}
      />
    </div>
  )
}

export default BackSearch;
